// PreviewAsAside.js
// The teacher home's "preview as {student}" control shown beside the
// Explore section header, letting a teacher scope journey/mission previews
// to a roster student (or their own account). Extracted out of
// TeacherHomeScreen.js to keep that screen under its line budget -- no
// behavior change from what lived there inline.
// See docs/superpowers/specs/2026-09-29-home-finish.md §F4d.
import React from "react";

import HomeSelect from "../primitives/HomeSelect";

const identity = (s) => s;

const PreviewAsAside = ({
  students = [],
  selectedJourneyStudentEmail = "",
  onSelectedJourneyStudentEmailChange = null,
  isDarkMode = false,
  t = identity,
}) => {
  const selectedStudent =
    students.find((student) => student?.email === selectedJourneyStudentEmail) || null;

  const items = [
    { key: "", label: t("My own") },
    ...students.map((student) => ({
      key: student?.email || "",
      label: student?.name || student?.email || "",
    })),
  ];
  const valueLabel = selectedStudent ? selectedStudent.name || selectedStudent.email : t("My own");

  return (
    <HomeSelect
      label={t("Preview as")}
      valueLabel={valueLabel}
      items={items}
      selectedKey={selectedJourneyStudentEmail || ""}
      onChange={(key) => onSelectedJourneyStudentEmailChange?.(String(key || ""))}
      isDarkMode={isDarkMode}
      t={t}
      testID="teacher-home-preview-select"
    />
  );
};

export default PreviewAsAside;
